import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Divider,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseRelatedProduct } from "./UseRelatedProduct";
import SearchComProduct from "./SearchComProduct";
import BrandSearchCom from "../../basic-information/brand/BrandSearchCom";
import SelectGroup from "../../ContentManagement/firstPage/HomeOffer/SelectGroup";
import { useSnackbar } from "notistack";
import { toMoney, removeComma } from "../../util/Utils";
import ClearIcon from "@mui/icons-material/Clear";
import RelatedPSearchCom from "./RelatedPSearchCom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { toSolar } from "jdate-convert";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddRelatedProduct(props) {
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [valueDate, setValueDate] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const {
    getProductTypes,
    addRelatedProducts,
    deleteRelatedProducts,
    getFilterCount,
  } = UseRelatedProduct();
  const [name, setName] = useState("");
  const [openRelated, setOpenRelated] = useState(false);
  const [filterCount, setFilterCount] = useState();
  const [productTypes, setProductTypes] = useState();
  const [giftName, setRelatedName] = useState("");
  const [state, setState] = useState({
    productID: undefined,
    brandID: undefined,
    groupID: undefined,
    minCost: 0,
    maxCost: 0,
    relatedID: undefined,
    expireDate: undefined,
    type: undefined,
  });
  const Months = [
    { id: 1, value: "1 ماه" },
    { id: 2, value: "2 ماه" },
    { id: 3, value: "3 ماه" },
    { id: 4, value: "4 ماه" },
    { id: 5, value: "5 ماه" },
    { id: 6, value: "6 ماه" },
    { id: 7, value: "7 ماه" },
    { id: 8, value: "8 ماه" },
    { id: 9, value: "9 ماه" },
    { id: 10, value: "10 ماه" },
    { id: 11, value: "11 ماه" },
    { id: 12, value: "12 ماه" },
  ];
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (openRelated) {
      getProductTypes((callback) => {
        setProductTypes(callback);
      });
      let newBody = Object.fromEntries(
        Object.entries(state).filter(([_, v]) => v != undefined)
      );
      getFilterCount(newBody, (callback) => {
        setFilterCount(callback);
      });
    }
  }, [openRelated]);

  useEffect(() => {
    let newValueStart = valueDate?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, expireDate: newValueStart });
  }, [valueDate]);

  return (
    <Box>
      <Dialog
        open={openRelated}
        maxWidth="sm"
        sx={{
          "& .MuiPaper-root ": {
            height: "50%",
          },
        }}
        fullWidth
        onClose={() => {
          setValueDate();
          setState({
            ...state,
            relatedID: undefined,
            expireDate: undefined,
          });
          setRelatedName("");
          setOpenRelated(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography color="secondary" variant="subtitle2">
              {filterCount} مورد یافت شد
            </Typography>
            <IconButton
              onClick={() => {
                setState({
                  ...state,
                  relatedID: undefined,
                });
                setRelatedName("");
                setOpenRelated(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 1 }} />
          <Box>
            <Typography variant="subtitle2">
              لطفا کد محصول مرتبط مورد نظر را وارد کنید
            </Typography>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <RelatedPSearchCom
                productID={state.relatedID}
                productModel={state}
                setProductModel={setState}
              />
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  my: 2,
                  gap: 2,
                }}
              >
                <DatePicker
                  calendarPosition="left-center"
                  // highlightToday={false}
                  onOpenPickNewDate={false}
                  weekDays={weekDays}
                  calendar={persian}
                  locale={persian_fa}
                  format="YYYY-MM-DD"
                  value={
                    state && state.expireDate ? toSolar(state.expireDate) : ""
                  }
                  onChange={setValueDate}
                  render={
                    <TextField
                      sx={{ input: { textAlign: "center" } }}
                      variant="outlined"
                      size="small"
                      fullWidth
                      label="انقضا"
                    />
                  }
                />
                <Autocomplete
                  size="small"
                  // value={state.headerColorName ? state.headerColorName : ""}
                  onChange={(event, newValue) => {
                    const today = new Date();
                    const month = today.getMonth();
                    today.setMonth(month + newValue);

                    // let expireDate = new Date().toJSON().slice(0, 10);
                    let expireDate = today.toJSON().slice(0, 10);

                    setState({
                      ...state,
                      expireDate: expireDate,
                    });
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  getOptionLabel={(option) => {
                    if (option) {
                      return Months.find((m) => m.id == option).value;
                    }
                    return "";
                  }}
                  sx={{ width: "60%" }}
                  options={Months ? Months.map((m) => m.id) : []}
                  renderInput={(params) => (
                    <TextField
                      variant="outlined"
                      {...params}
                      label="تعداد ماه"
                    />
                  )}
                />
              </Box>
              <Box sx={{ width: "100%", mb: 2 }}>
                <Autocomplete
                  size="small"
                  // value={state.headerColorName ? state.headerColorName : ""}
                  onChange={(event, newValue) => {
                    setState({
                      ...state,
                      type: newValue,
                    });
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  getOptionLabel={(option) => {
                    if (option) {
                      return productTypes.find((m) => m.id == option).type;
                    }
                    return "";
                  }}
                  sx={{ width: "60%" }}
                  options={productTypes ? productTypes.map((m) => m.id) : []}
                  renderInput={(params) => (
                    <TextField variant="outlined" {...params} label="نوع" />
                  )}
                />
              </Box>
              {/* {state.productID ? (
                <Box sx={{ width: "100%", mb: 2 }}>
                  <FormControlLabel
                    checked={state.withDiscount ? state.withDiscount : false}
                    onChange={(evt) => {
                      setState({ ...state, withDiscount: evt.target.checked });
                    }}
                    control={<Checkbox sx={{ py: 0 }} />}
                    label="عدم نمایش اتوماتیک محصولات"
                  />
                </Box>
              ) : (
                ""
              )} */}
              <Box>
                <Button
                  onClick={() => {
                    if (!state.relatedID) {
                      enqueueSnackbar("لطفا کد محصول مرتبط را وارد کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                      });
                      return;
                    }
                    if (!state.expireDate) {
                      enqueueSnackbar("لطفا تاریخ انقضا را وارد کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                      });
                      return;
                    }
                    if (!state.type) {
                      enqueueSnackbar("لطفا نوع را وارد کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                      });
                      return;
                    }
                    addRelatedProducts(state, () => {
                      setRelatedName("");
                      setOpenRelated(false);
                      setState({
                        productID: undefined,
                        brandID: undefined,
                        groupID: undefined,
                        minCost: undefined,
                        maxCost: undefined,
                        relatedID: undefined,
                        expireDate: undefined,
                      });
                      setValueDate();
                      props.callback();
                    });
                  }}
                  sx={{ mr: 2 }}
                  color="secondary"
                  variant="contained"
                >
                  افزون
                </Button>
                <Button
                  onClick={() => {
                    if (!state.type) {
                      enqueueSnackbar("لطفا نوع را وارد کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                      });
                      return;
                    }
                    let model = {
                      productID: state.productID ? state.productID : undefined,
                      brandID: state.brandID ? state.brandID : undefined,
                      groupID: state.groupID ? state.groupID : undefined,
                      type: state.type ? state.type : undefined,
                      minCost: state.minCost ? state.minCost : 0,
                      maxCost: state.maxCost ? state.maxCost : 0,
                      expireDate: state.expireDate
                        ? state.expireDate
                        : undefined,
                      relatedID: 0,
                    };
                    deleteRelatedProducts(model, () => {
                      setOpenRelated(false);
                      setRelatedName("");
                      setState({
                        productID: undefined,
                        brandID: undefined,
                        groupID: undefined,
                        type: undefined,
                        minCost: undefined,
                        maxCost: undefined,
                        relatedID: undefined,
                        expireDate: undefined,
                      });
                      props.callback();
                    });
                  }}
                  color="secondary"
                  variant="outlined"
                >
                  حذف
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}>
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          براساس محصول
        </Typography>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 9"}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <SearchComProduct
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
            />

            <Button
              sx={{ width: "70px" }}
              variant="contained"
              disabled={!state.productID ? true : false}
              onClick={() => {
                setOpenRelated(true);
              }}
            >
              عملیات
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{ mt: 4, mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          براساس برند
        </Typography>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn={isSmall ? "span 12" : "span 4"}>
          <BrandSearchCom
            setName={setName}
            selectedBrandID={state.brandID}
            setter={setState}
            lvl1State={state}
          ></BrandSearchCom>
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 8"}
        >
          <TextField
            sx={{
              width: isSmall ? "40%" : "25%",
              input: {
                textAlign: "center",
              },
            }}
            disabled={!state.brandID ? true : false}
            value={state.brandID && state.minCost ? toMoney(state.minCost) : ""}
            label="حداقل قیمت (تومان)"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              if (state.brandID) {
                setState({
                  ...state,
                  minCost: removeComma(evt.target.value),
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            disabled={!state.brandID ? true : false}
            sx={{
              width: isSmall ? "40%" : "25%",
              input: {
                textAlign: "center",
              },
            }}
            value={state.brandID && state.maxCost ? toMoney(state.maxCost) : ""}
            label="حداکثر قیمت (تومان)"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              if (state.brandID) {
                setState({
                  ...state,
                  maxCost: removeComma(evt.target.value),
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button
            disabled={!state.brandID ? true : false}
            sx={{ mr: 2, width: "70px" }}
            variant="contained"
            onClick={() => {
              setState({
                ...state,
                productID: undefined,
                groupID: undefined,
              });
              setOpenRelated(true);
            }}
          >
            عملیات
          </Button>
        </Box>
      </Box>
      <Box
        sx={{ mt: 4, mb: 2, display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <FiberManualRecordIcon color="secondary" fontSize="small" />
        <Typography color="secondary" variant="subtitle1">
          براساس گروه
        </Typography>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
        <Box gridColumn="span 12">
          <SelectGroup
            Related
            Offer
            selectedGroupID={state.groupID && state.groupID}
            name={name}
            setName={setName}
            setter={setState}
            lvl1State={state}
          ></SelectGroup>
        </Box>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 8"}
        >
          <TextField
            disabled={!state.groupID ? true : false}
            sx={{
              width: isSmall ? "40%" : "25%",
              input: {
                textAlign: "center",
              },
            }}
            value={state.groupID && state.minCost ? toMoney(state.minCost) : ""}
            label="حداقل قیمت (تومان)"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              if (state.groupID) {
                setState({
                  ...state,
                  minCost: removeComma(evt.target.value),
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            disabled={!state.groupID ? true : false}
            sx={{
              width: isSmall ? "40%" : "25%",
              input: {
                textAlign: "center",
              },
            }}
            value={state.groupID && state.maxCost ? toMoney(state.maxCost) : ""}
            label="حداکثر قیمت (تومان)"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              if (state.groupID) {
                setState({
                  ...state,
                  maxCost: removeComma(evt.target.value),
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Button
            disabled={!state.groupID ? true : false}
            sx={{ mr: 2, width: "70px" }}
            variant="contained"
            onClick={() => {
              setState({
                ...state,
                productID: undefined,
                brandID: undefined,
              });
              setOpenRelated(true);
            }}
          >
            عملیات
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
